import { AttributeDetailModel } from '@leverege/ui-attributes';
const TYPE = 'attr.detail.staticImageValue';
function create(attrName, objectType) {
  return {
    ...AttributeDetailModel.create(attrName, objectType),
    type: TYPE
  };
}
export default {
  create,
  TYPE
};